import React from 'react';

import AllergyCheckForImmunotherapySante24EN from './EmailsData/AllergyCheckForImmunotherapy/Sante24/EN';
import AllergyCheckForImmunotherapySante24DE from './EmailsData/AllergyCheckForImmunotherapy/Sante24/DE';
import AllergyCheckForImmunotherapySante24FR from './EmailsData/AllergyCheckForImmunotherapy/Sante24/FR';
import AllergyCheckForImmunotherapySante24IT from './EmailsData/AllergyCheckForImmunotherapy/Sante24/IT';

import WeightLossTreatmentCheckStefanZechmannEN from './EmailsData/WeightLossTreatmentCheck/StefanZechmann/EN';
import WeightLossTreatmentCheckStefanZechmannDE from './EmailsData/WeightLossTreatmentCheck/StefanZechmann/DE';
import WeightLossTreatmentCheckStefanZechmannFR from './EmailsData/WeightLossTreatmentCheck/StefanZechmann/FR';
import WeightLossTreatmentCheckStefanZechmannIT from './EmailsData/WeightLossTreatmentCheck/StefanZechmann/IT';

import FatigueCheckStefanZechmannEN from './EmailsData/FatigueCheck/StefanZechmann/EN';
import FatigueCheckStefanZechmannDE from './EmailsData/FatigueCheck/StefanZechmann/DE';
import FatigueCheckStefanZechmannFR from './EmailsData/FatigueCheck/StefanZechmann/FR';
import FatigueCheckStefanZechmannIT from './EmailsData/FatigueCheck/StefanZechmann/IT';

import { LanguageCode } from '../types';
import { PartnerCodes } from '../../../../constants/partner/partnerCodes';
import { TestTypes } from '../../../../constants/test/testTypes';

type TemplateComponent = JSX.Element;

type PartnerTemplateMap = Record<LanguageCode, TemplateComponent>;

type TemplateMap = Partial<
  Record<TestTypes, Partial<Record<PartnerCodes, PartnerTemplateMap>>>
>;

const templates: TemplateMap = {
  [TestTypes.ALLERGY_CHECK_FOR_IMMUNOTHERAPY]: {
    [PartnerCodes.S24]: {
      en: <AllergyCheckForImmunotherapySante24EN />,
      de: <AllergyCheckForImmunotherapySante24DE />,
      fr: <AllergyCheckForImmunotherapySante24FR />,
      it: <AllergyCheckForImmunotherapySante24IT />,
    },
  },
  [TestTypes.WEIGHT_LOSS_TREATMENT_CHECK]: {
    [PartnerCodes.STEFAN_ZECHMANN]: {
      en: <WeightLossTreatmentCheckStefanZechmannEN />,
      de: <WeightLossTreatmentCheckStefanZechmannDE />,
      fr: <WeightLossTreatmentCheckStefanZechmannFR />,
      it: <WeightLossTreatmentCheckStefanZechmannIT />,
    },
  },
  [TestTypes.FATIGUE_V3]: {
    [PartnerCodes.STEFAN_ZECHMANN]: {
      en: <FatigueCheckStefanZechmannEN />,
      de: <FatigueCheckStefanZechmannDE />,
      fr: <FatigueCheckStefanZechmannFR />,
      it: <FatigueCheckStefanZechmannIT />,
    },
  },
};

export const getBody = (
  partnerCode: PartnerCodes,
  testType: TestTypes,
  language: LanguageCode,
  isAdmin?: boolean,
): JSX.Element | null => {
  const testTemplates = templates[testType];
  if (!testTemplates) return null;

  const partnerTemplates =
    testTemplates[partnerCode] ??
    (isAdmin ? Object.values(testTemplates)[0] : undefined);

  return partnerTemplates?.[language] || null;
};
